module.exports = __webpack_public_path__ + "static/media/picture-quiz-bgm.40ab5858.mp3";